import Ripple from 'vue-ripple-directive'
import Vue from "vue";

Ripple.transition = 200;
Ripple.color = 'rgba(232,232,232,0.35)';

Vue.directive('ripple', Ripple);
